const normalizePath = (path: string): string => {
  return path.replace('/', '')
}

const composeUrl = ({
  protocol = '',
  host = '',
  basepath = '',
}): string => {
  let requestPath = `${protocol}://${host}`
  if (basepath) requestPath = `${requestPath}/${basepath}`

  return requestPath
}

const getProtocol = (): 'http' | 'http' =>
  location.protocol.replace(':', '') as any

export { normalizePath, composeUrl, getProtocol }
